import React from 'react';
import Tooltip from '@mui/material/Tooltip';

import { ICONS } from '../../../../../icons';
import Icon from '../../../../../icons/Icon';
import CommonButton from '../../../../../components/common-button/CommonButton';

import scss from './ShareSection.module.scss';

const RegenerateButton = ({ onClick, disabled }) => {
  return (
    <Tooltip title='Generate' disableHoverListener={disabled}>
      <div>
        <CommonButton
          styleColor='secondary'
          className={scss.genButton}
          onClick={onClick}
          isStrokeIcon
          disabled={disabled}>
          <Icon icon={ICONS.Reload} currentColor disableCommonColors />
        </CommonButton>
      </div>
    </Tooltip>
  );
};

export default RegenerateButton;
